/* eslint-disable react/react-in-jsx-scope */
import { Grid, Typography } from '@mui/material'
import IReportGroup from '../../interfaces/IReportGroup'
import IReportColumn from '../../interfaces/IReportColumn'
import ReportColumns from '../ReportColumns'
import RenderDetaildReport from './RenderDetaildReport'

export default function GroupedReportWithoutTable({
  groups,
  columns,
  isTwoLevels,
}: {
  readonly isTwoLevels?: boolean
  readonly groups: readonly IReportGroup[]
  readonly columns: readonly IReportColumn[]
}) {
  
  return (
    <Grid container marginTop={1}>
      {groups.map((group) => {
        return (
          <Grid item key={Math.random() + group.count} xs={24} marginTop={1}>
            <Typography variant="body2" marginTop={1} fontWeight={'bold'}>
              {group.label}
              {group.count ? ` (Total : ${group.total}) ` : ''}
              {group.details?.class === 'dispatch' ||
              group.details?.class === 'device_log' ||
              group.details?.class == 'entry' ||
              group.details?.class == 'approach' ||
              group.details?.class == 'device_productivity' ||
              group.details?.class == 'qualifier_peoples' ||
              group.details?.class == 'qualifier_vehicles'||
              group.details?.class == 'qualifier_animals'||
              group.details?.class == 'qualifier_drugs'||
              group.details?.class == 'qualifier_organizations'||
              group.details?.class == 'qualifier_weapons'||
              group.details?.class == 'qualifier_objects'? (
                <RenderDetaildReport details={group.details} />
              ) : (
                false
              )}
            </Typography>
            <ReportColumns
              indentation={isTwoLevels ? false : true}
              columns={columns}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
